<life-di-nav></life-di-nav>
<lifedi-breadcrumb></lifedi-breadcrumb>

<div class="container" *ngIf="isEdit && newsData">
  <button mat-mini-fab color="warn" class="float-right btn-delete" (click)="delete(newsData.NEWS_ID)">
    <img src="../../../../assets/delete.png" style="width: 22px; margin-left: 4px; margin-top: -4px;">
  </button>
</div>

<!-- CREATE -->

<div class="container" *ngIf="!isEdit && !newsData">
  <h1 class="text-center lifedi-color">สร้างข่าว</h1>
  <form [formGroup]="newsForm">
    <div class="form-group row">
      <label for="topic" class="col-4 col-form-label text-right">หัวข้อข่าว<lifedi-require></lifedi-require></label>
      <div class="col-5">
        <input type="text" class="form-control" id="topic" formControlName="newsTital" autocomplete="off">
      </div>
    </div>
    <div class="form-group row">
      <label for="cover" class="col-4 col-form-label text-right">รูปภาพปก<lifedi-require></lifedi-require></label>
      <div class="col-5">
        <div class="custom-file">
          <input type="file" class="custom-file-input" id="customFile" accept=".png, .jpg, .jpeg"
            (change)="onFileSelected($event, newsForm)">
          <label *ngIf="!coverName" class="custom-file-label" for="customFile">Choose file</label>
          <label *ngIf="coverName" class="custom-file-label" for="customFile">{{ coverName }}</label>
        </div>
      </div>
    </div>
    <div class="form-group row">
      <label for="type" class="col-4 col-form-label text-right">ประเภท<lifedi-require></lifedi-require></label>
      <div class="col-5">
        <select class="custom-select" id="type" formControlName="newsCategory">
          <option *ngFor="let c of category" [value]="c.CATEGORY_NAME">{{ c.CATEGORY_NAME }}</option>
        </select>
      </div>
    </div>
    <div class="form-group row">
      <label for="timeToClose" class="col-4 col-form-label text-right">เวลาเปิด / ปิดข่าว<lifedi-require>
        </lifedi-require></label>
      <div class="col-5">
        <input [attr.disabled]="newsForm.newsAlwaysOpen ? true : null " type="text"
          placeholder="เลือกเวลาเปิด / ปิดข่าว" class="form-control" formControlName="newsDate" bsDaterangepicker
          id="timeToClose" autocomplete="off"
          [bsConfig]="{ isAnimated: true, rangeInputFormat : ' DD-MM-YYYY ', dateInputFormat: ' DD-MM-YYYY ', showWeekNumbers: false, containerClass: 'theme-red' }">
      </div>
      <div class="col-2 justify-content-center align-self-center">
        <section>
          <mat-checkbox id="newsAlwaysOpen" color="primary" formControlName="newsAlwaysOpen"
            (click)="clearValueNewsDate(newsForm)" [(ngModel)]="newsForm.newsAlwaysOpen">เปิดตลอด
          </mat-checkbox>
        </section>
      </div>
    </div>
    <div class="form-group row">
      <label for="type" class="col-4 col-form-label text-right">ศูนย์ย่อย</label>
      <div class="col-5">
        <nz-select nzMode="multiple" [nzTokenSeparators]="[',']" #value [change]="patchLearning(value, newsForm)"
          style="width: 100%">
          <nz-option *ngFor="let center of allLearningCenter" [nzLabel]="center.CENTER_NAME" [nzValue]="center"></nz-option>
        </nz-select>
      </div>
    </div>
    <br />
    <h5 class="text-center">เนื้อหาข่าว<lifedi-require></lifedi-require>
    </h5>
    <br />
    <angular-editor id="_content" formControlName="newsContent" placeholder="ใส่เนื้อหาข่าว" style="margin: 0 auto;"
      [config]="editorConfig">
    </angular-editor>
  </form>
  <div style="margin: 15px auto; padding-bottom: 10px; width: fit-content;">
    <lifedi-btn lable="Preview" *ngIf="newsForm.valid" (click)="preview(newsForm.value, isEdit)"
      customStyle=" color:white; background-color: #414A6B; width: 300px;">
    </lifedi-btn>
    <lifedi-btn lable="Preview" *ngIf="!newsForm.valid" [disabled]="!newsForm.valid" customStyle="width: 300px;">
    </lifedi-btn>
  </div>
</div>


<!-- DUPLICATE -->

<div class="container" *ngIf="!isEdit && newsData">
  <h1 class="text-center lifedi-color">สร้างข่าว</h1>
  <form [formGroup]="newsFormEdit">
    <div class="form-group row">
      <label for="topic" class="col-4 col-form-label text-right">หัวข้อข่าว<lifedi-require></lifedi-require></label>
      <div class="col-5">
        <input type="text" class="form-control" id="topic" formControlName="newsTital" autocomplete="off"
          [(ngModel)]="newsData.NEWS_TITAL">
      </div>
    </div>
    <div class="form-group row">
      <label for="cover" class="col-4 col-form-label text-right">รูปภาพปก<lifedi-require></lifedi-require></label>
      <div class="col-5">
        <div class="custom-file">
          <input type="file" class="custom-file-input" id="customFile" accept=".png, .jpg, .jpeg"
            (change)="onFileSelected($event, newsFormEdit)">
          <label *ngIf="!coverName" class="custom-file-label" for="customFile">Choose file</label>
          <label *ngIf="coverName" class="custom-file-label" for="customFile">{{ coverName }}</label>
        </div>
      </div>
    </div>
    <div class="form-group row">
      <label for="type" class="col-4 col-form-label text-right">ประเภท<lifedi-require></lifedi-require></label>
      <div class="col-5">
        <select class="custom-select" id="type" formControlName="newsCategory" [(ngModel)]="newsData.NEWS_CATEGORY">
          <option *ngFor="let c of category" [value]="c.CATEGORY_NAME">{{c.CATEGORY_NAME}}</option>
        </select>
      </div>
    </div>
    <div class="form-group row">
      <label for="timeToClose" class="col-4 col-form-label text-right">เวลาเปิด / ปิดข่าว
        <lifedi-require></lifedi-require>
      </label>
      <div class="col-5">
        <input [attr.disabled]="newsData.ALWAYS_OPEN ? true : null" type="text" placeholder="เลือกเวลาเปิด / ปิดข่าว"
          class="form-control" formControlName="newsDate" bsDaterangepicker id="timeToClose" autocomplete="off"
          [(ngModel)]="dateTime"
          [bsConfig]="{ isAnimated: true, rangeInputFormat : ' DD-MM-YYYY ', dateInputFormat: ' DD-MM-YYYY ', showWeekNumbers: false, containerClass: 'theme-red' }">
      </div>
      <div class="col-2 justify-content-center align-self-center">
        <section>
          <mat-checkbox id="newsAlwaysOpen" color="primary" formControlName="newsAlwaysOpen"
            (click)="clearValueNewsDate(newsFormEdit)" [(ngModel)]="newsData.ALWAYS_OPEN">เปิดตลอด</mat-checkbox>
        </section>
      </div>
    </div>
    <div class="form-group row">
      <label for="type" class="col-4 col-form-label text-right">ศูนย์ย่อย</label>
      <div class="col-5">
        <nz-select nzMode="multiple" [nzTokenSeparators]="[',']" #value [(ngModel)]="newsData.LN_TAG" [ngModelOptions]="{standalone: true}" [change]="patchLearning(value, newsFormEdit)"
          style="width: 100%" [compareWith]="compareFn">
          <nz-option *ngFor="let center of allLearningCenter" [nzLabel]="center.CENTER_NAME" [nzValue]="center"></nz-option>
        </nz-select>
      </div>
    </div>
    <br />
    <h5 class="text-center">เนื้อหาข่าว<lifedi-require></lifedi-require></h5>
    <br />
    <angular-editor id="_content" formControlName="newsContent" placeholder="ใส่เนื้อหาข่าว" style="margin: 0 auto;"
      [config]="editorConfig" [(ngModel)]="newsData.NEWS_DETAIL">
    </angular-editor>
  </form>
  <div style="margin: 15px auto; padding-bottom: 10px; width: fit-content;">
    <lifedi-btn lable="Preview" *ngIf="newsFormEdit.valid" (click)="preview(newsFormEdit.value, isEdit)"
      customStyle=" color:white; background-color: #414A6B; width: 300px;">
    </lifedi-btn>
    <lifedi-btn lable="Preview" *ngIf="!newsFormEdit.valid" [disabled]="!newsFormEdit.valid"
      customStyle="width: 300px;">
    </lifedi-btn>
  </div>
</div>

<!-- EDIT -->

<div class="container" *ngIf="isEdit && newsData">
  <!-- {{ newsData|json }} -->
  <h1 class="text-center lifedi-color">แก้ไขข่าว</h1>
  <form [formGroup]="newsFormEdit">
    <div class="form-group row">
      <label for="topic" class="col-4 col-form-label text-right">หัวข้อข่าว<lifedi-require></lifedi-require></label>
      <div class="col-5">
        <input type="text" class="form-control" id="topic" formControlName="newsTital" autocomplete="off"
          [(ngModel)]="newsData.NEWS_TITAL">
      </div>
    </div>
    <div class="form-group row">
      <label for="cover" class="col-4 col-form-label text-right">รูปภาพปก<lifedi-require></lifedi-require></label>
      <div class="col-5">
        <div class="custom-file">
          <input type="file" class="custom-file-input" id="customFile" accept=".png, .jpg, .jpeg"
            (change)="onFileSelected($event, newsFormEdit)">
          <label *ngIf="!coverName" class="custom-file-label" for="customFile">Choose file</label>
          <label *ngIf="coverName" class="custom-file-label" for="customFile">{{ coverName }}</label>
        </div>
      </div>
    </div>
    <div class="form-group row">
      <label for="type" class="col-4 col-form-label text-right">ประเภท<lifedi-require></lifedi-require></label>
      <div class="col-5">
        <select class="custom-select" id="type" formControlName="newsCategory" [(ngModel)]="newsData.NEWS_CATEGORY">
          <option *ngFor="let c of category" [value]="c.CATEGORY_NAME">{{c.CATEGORY_NAME}}</option>
        </select>
      </div>
    </div>
    <div class="form-group row">
      <label for="timeToClose" class="col-4 col-form-label text-right">เวลาเปิด /
        ปิดข่าว<lifedi-require></lifedi-require></label>
      <div class="col-5">
        <input [attr.disabled]="newsData.ALWAYS_OPEN ? true : null" type="text" placeholder="เลือกเวลาเปิด / ปิดข่าว"
          class="form-control" formControlName="newsDate" bsDaterangepicker id="timeToClose" autocomplete="off"
          [(ngModel)]="dateTime"
          [bsConfig]="{ isAnimated: true, rangeInputFormat : ' DD-MM-YYYY ', dateInputFormat: ' DD-MM-YYYY ', showWeekNumbers: false, containerClass: 'theme-red' }">
      </div>
      <div class="col-2 justify-content-center align-self-center">
        <section>
          <mat-checkbox id="newsAlwaysOpen" color="primary" formControlName="newsAlwaysOpen"
            (click)="clearValueNewsDate(newsFormEdit)" [(ngModel)]="newsData.ALWAYS_OPEN">เปิดตลอด</mat-checkbox>
        </section>
      </div>
    </div>
    <div class="form-group row">
      <label for="type" class="col-4 col-form-label text-right">ศูนย์ย่อย</label>
      <div class="col-5">
        <nz-select nzMode="multiple" [nzTokenSeparators]="[',']" #value [(ngModel)]="newsData.LN_TAG" [ngModelOptions]="{standalone: true}" [change]="patchLearning(value, newsFormEdit)"
          style="width: 100%" [compareWith]="compareFn">
          <nz-option *ngFor="let center of allLearningCenter" [nzLabel]="center.CENTER_NAME" [nzValue]="center"></nz-option>
        </nz-select>
      </div>
    </div>
    <br />
    <h5 class="text-center">เนื้อหาข่าว<lifedi-require></lifedi-require></h5>
    <br />
    <angular-editor id="_content" formControlName="newsContent" placeholder="ใส่เนื้อหาข่าว" style="margin: 0 auto;"
      [config]="editorConfig" [(ngModel)]="newsData.NEWS_DETAIL">
    </angular-editor>
  </form>
  <div style="margin: 15px auto; padding-bottom: 10px; width: fit-content;">
    <lifedi-btn lable="Preview" *ngIf="newsFormEdit.valid" (click)="preview(newsFormEdit.value, isEdit)"
      customStyle="color:white; background-color: #005C3D; width: 300px;">
    </lifedi-btn>
    <lifedi-btn lable="Preview" *ngIf="!newsFormEdit.valid" [disabled]="!newsFormEdit.valid"
      customStyle="width: 300px;">
    </lifedi-btn>
  </div>
</div>